import TutorAd from './tutor-ad';

export default TutorAd;
